import { styled } from '@nykaa/ui-components';
export const ColorsStrip = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;
export const ColorOption = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  height: 16px;
  width: 16px;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  ${({ theme }) => theme.borders.border100};
  border-color: ${({ theme }) => theme.colors.textOutline};
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  &:last-of-type {
    margin-right: ${({ theme }) => theme.spacing.spacing40};
  }
`;

export const ColorText = styled.span`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};
`;
